<template>
  <footer class="container mt-5">
    <div class="row justify-content-center text-center">

      <!-- العمود الرابع على الأجهزة الكبيرة - الأول على الأجهزة الصغيرة -->
      <div class="col-lg-3 col-12 order-1 order-lg-4 d-flex flex-column align-items-center">
        <h2>{{$t('KEEP UP TO DATE')}}</h2>
       
        <p class="mt-6 description_footer" style=" padding-top: 4%;">
                                        
                                        {{ DBitems.market.name }}
                                        {{ DBitems.market.description }}
                                   </p>
                                   <p v-if="DBitems.market.subdescription" 
                                   class="mt-6 text-gray-300 description_footer">
                                        {{ DBitems.market.subdescription }}
                                  </p>
      </div>

      <!-- العمود الأول -->
      <div class="col-lg-3 col-12 order-lg-1 d-flex flex-column align-items-center">
        <img :src="this.$store.state.logo_footer" class="logo_footer" width="100%">

        <div class="d-flex mt-3 justify-content-center">
          <a v-if="DBitems.social.facebook" :href="DBitems.social.facebook" class="icon-circle">
            <i class="fa fa-facebook-f icon_footer" style="color: #324FBE;"></i>
          </a>

          <a v-if="DBitems.social.twiter" :href="DBitems.social.twiter" class="icon-circle">
            <i class="fa fa-twitter icon_footer" style="color:rgb(89, 89, 233) "></i>
          </a>
          <a v-if="DBitems.social.instgram" :href="DBitems.social.instgram" class="icon-circle">
            <i class="fa fa-instagram icon_footer" style="color: pink;"></i>
          </a>
        </div>
      </div>

      <!-- العمود الثاني -->
      <div class="col-lg-3 col-6 order-lg-2 d-flex flex-column align-items-center">
        <h4>{{ $t('shop') }}</h4>
        <ul class="list-unstyled">
          <li v-for="(item, index) in this.DBitems.sections" :key="index" class="list_footer">
            <router-link :to="{
              name: 'section',
              params: { storeName: $store.storeName, id: item.id, name: item.label, lang: $i18n.locale },
            }">
            <!-- <i class="fa fa-long-arrow-right icon_footer_arrow"></i> -->
            {{ item.label }}</router-link>
          </li>

        </ul>
      </div>

      <!-- العمود الثالث -->
      <div class="col-lg-3 col-6 order-lg-3 d-flex flex-column align-items-center">
        <h4>{{ $t('about') }}</h4>
        <ul class="list-unstyled">
          <li class="list_footer"><router-link 
                              :to="{
                               name: 'shopping_cart',
                              params: { storeName: this.$store.storeName,lang: $i18n.locale },
                                   }"
                            >
                            <!-- <i class="fa fa-long-arrow-right icon_footer_arrow"></i> -->
                            {{ $t('shoppingCart') }}</router-link>
                          </li>
          <li class="list_footer">   
            <!-- <i class="fa fa-long-arrow-right icon_footer_arrow"></i> -->
            <router-link :to="{
                          name: 'about',
                          params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
                        }" >
                         
                          {{ $t('about') }} </router-link></li>
          <li class="list_footer">            
             <!-- <i class="fa fa-long-arrow-right icon_footer_arrow"></i> -->
            <router-link :to="{
                          name: 'privacy',
                          params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
                        }" >
                        {{ $t('privacyPolicy') }} </router-link></li>
          <li class="list_footer" >           
             <!-- <i class="fa fa-long-arrow-right icon_footer_arrow"></i> -->
            <router-link :to="{
                          name: 'sections',
                          params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
                        }" >
                           {{ $t('sections') }} </router-link></li>
          <li class="list_footer">
            <router-link :to="{
                          name: 'products',
                          params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
                        }" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out">
                                       <!-- <i class="fa fa-long-arrow-right icon_footer_arrow"></i> -->
                                       {{ $t('products') }} </router-link></li>
        </ul>
      </div>

    </div>


  </footer>
</template>
<script>
export default {

  name: "Footer",
  props: {

  },
  data: function () {
    return {
      logo: "",
      DBitems: null,
      loading: false,
    };
  },
  created() {
    this.loading = true;
    this.$store.storeName = this.$store.state.storeName;
    console.log(this.$store.storeName);
    this.axios
      .get(this.$store.state.base_api_url + this.$store.storeName + "/footer_theme5",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        })
      .then((response) => (this.DBitems = response.data.data
      ))
      .then(() => (this.loading = false));

  },
  methods: {
    updatedata() {
      this.loading = true;
      this.$store.storeName = this.$store.state.storeName;
      console.log(this.$store.storeName);
      this.axios
        .get(this.$store.state.base_api_url + this.$store.storeName + "/footer_theme5",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          })
        .then((response) => (this.DBitems = response.data.data
        ))
        .then(() => (this.loading = false));

    }
  },
  watch: {
    langChange() {
      this.loading = true;
      this.$store.storeName = this.$store.state.storeName;
      console.log(this.$store.storeName);
      this.axios
        .get(this.$store.state.base_api_url + this.$store.storeName + "/footer_theme5",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          })
        .then((response) => (this.DBitems = response.data.data
        ))
        .then(() => (this.loading = false));

    },
    langChange1() {
      this.loading = true;
      this.$store.storeName = this.$store.state.storeName;
      console.log(this.$store.storeName);
      this.axios
        .get(this.$store.state.base_api_url + this.$store.storeName + "/footer_theme5",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          })
        .then((response) => (this.DBitems = response.data.data
        ))
        .then(() => (this.loading = false));

    },
  },

};
</script>